
  (function () {
    function toggleWidget() {
      var cartOpen = document.querySelector('details.cart-drawer-container[open]');
      var widget = document.getElementById('zipchat-shadow-host');
      if (widget) {
        widget.style.setProperty('display', cartOpen ? 'none' : 'contents', 'important');
      }
    }

    var observer = new MutationObserver(toggleWidget);
    var cartDrawer = document.querySelector('details.cart-drawer-container');
    if (cartDrawer) {
      observer.observe(cartDrawer, { attributes: true, attributeFilter: ['open', 'class'] });
    }

    // Run once on load in case it's already open
    toggleWidget();
  })();
